import WebDevelopment from "../img/web-development.png";
import DiscreteMath from "../img/discrete-math.png";
import Cryptography from "../img/cryptography.png";
import dataStructrue from "../img/dataStructure.png";
import python_cover from "../img/python.png";
import web2023 from "../img/NEWWEB3.png";
import MathBro from "../img/LA.png";
import Java from "../img/trying.png";
import Wave from "../components/Wave";
import AndroidCover from "../img/Android_Cover.png";
import MLCover from "../img/ML_Trans.png";
import DLCover from "../img/blank_dl.png";
// scroll animation
import { motion } from "framer-motion";
import { coursesAnimation, cardAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";
import { Link } from "react-router-dom";

const Courses = () => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1500 ? 0 : 0.25);

  return (
    <motion.div
      variants={coursesAnimation}
      initial="hidden"
      animate={controls}
      className="courses"
      ref={element}
      id="coursePart"
    >
      <div className="title">
        <h3>課程列表</h3>
      </div>

      <div className="cards">
        <motion.div variants={cardAnimation} className="card">
          <img src={DLCover} alt="" />
          <br />
          <br />
          <h2>
            <span>AI 人工智能：深度學習</span>
          </h2>
          <div className="content">
            <p>課程目標:</p>
            <p>
              學習深度學習的理論與實作，從神經網路原理、模型訓練到應用實踐，掌握
              DNN、CNN、GPT、Transformer 等主流架構!
            </p>
            <br />
            <p>學習內容:</p>
            <p>
              MLP、CNN、ResNet、RNN、LSTM、Transformer、GPT、BERT、CLIP、DALL-E、Diffusion、GAN、VAE、Tensorflow。
            </p>
          </div>
          <br />
          <div className="link">
            <motion.button
              whileTap={{
                scale: 0.6,
              }}
            >
              <Link to="/dl">查看課程</Link>
            </motion.button>
          </div>
          <div className="cline"></div>
        </motion.div>
        <motion.div variants={cardAnimation} className="card">
          <img src={MLCover} alt="" />
          <br />
          <br />
          <h2>
            <span>AI 人工智能：機器學習</span>
          </h2>
          <div className="content">
            <p>課程目標:</p>
            <p>
              學習機器學習的基礎理論與實作，從數據處理、模型訓練到應用，掌握AI技術的核心概念與實戰技能。
            </p>
            <br />
            <p>學習內容:</p>
            <p>
              Numpy、Pandas、Matplotlib、Seaborn
              等資料科學套件，以及機器學習演算法的數學計算到程式碼應用(Scikit-learn)。
            </p>
          </div>
          <br />
          <div className="link">
            <motion.button
              whileTap={{
                scale: 0.6,
              }}
            >
              <Link to="/ml">查看課程</Link>
            </motion.button>
          </div>
          <div className="cline"></div>
        </motion.div>
        <motion.div variants={cardAnimation} className="card">
          <img src={python_cover} alt="" />
          <br />
          <br />
          <h2>
            <span>2026 Python全攻略</span>
          </h2>
          <div className="content">
            <p>課程目標:</p>
            <p>
              學習Python語法、程式邏輯、運用Python網路爬蟲、連結SQL資料庫、處理Excel和csv、寄送email，一步步實作成為Python達人！
            </p>
            <br />
            <p>學習內容:</p>
            <p>
              基本與進階資料類型、運算、控制流程、Pythonic、文件處理、物件導向、繼承
              解析模組(Module)和套件(Package)的概念，實做網路爬蟲、透過sqlalchemy連結資料庫。
            </p>
          </div>
          <br />
          <div className="link">
            <motion.button
              whileTap={{
                scale: 0.6,
              }}
            >
              <Link to="/python">查看課程</Link>
            </motion.button>
          </div>
          <div className="cline"></div>
        </motion.div>

        <Wave />
      </div>

      <div className="cards topMargin">
        <motion.div variants={cardAnimation} className="card">
          <img src={web2023} alt="" />
          <br />
          <br />
          <h2>
            <span>2026 網頁全端開發</span>
          </h2>
          <div className="content">
            <p>課程目標:</p>
            <p>
              從無到有學習所有技能，透過九個專案實作，從前端、資料庫、後端，到React與Next完整學習網頁開發！
            </p>
            <br />
            <p>學習內容:</p>
            <p>
              HTML, CSS, JavaScript, ReactJS, NextJS, MySQL, Node.js,
              Express.js, EJS, MongoDB, Mongoose, Authentication,
              貪食蛇遊戲、彈跳球遊戲、MERN專案與雲端部署。
            </p>
          </div>
          <br />
          <div className="link">
            <motion.button
              whileTap={{
                scale: 0.6,
              }}
            >
              <Link to="/webdev">查看課程</Link>
            </motion.button>
          </div>
          <div className="cline"></div>
        </motion.div>
        <motion.div variants={cardAnimation} className="card">
          <img src={Java} alt="" />
          <br />
          <br />
          <h2>
            <span>2026 Java課程</span>
          </h2>
          <div className="content">
            <p>課程目標:</p>
            <p>
              學習Java物件導向程式設計，製作貪食蛇遊戲、面試題目解題、網頁開發、寫出多線程程式。
            </p>
            <br />
            <p>學習內容:</p>
            <p>
              Java 8語法, Inheritance, Encapsulation, Polymorphism,
              Multi-threaded, Stream API,
              貪食蛇遊戲製作、出埃及記遊戲製作、Socket Prgramming、JDBC,
              Servlet, JSP
            </p>
          </div>
          <br />
          {/* <div className="link">
            <button
              style={{
                background: "grey",
                color: "white",
              }}
            >
              <Link style={{ border: "none", color: "white" }} to="/java">
                即將上市
              </Link>
            </button>
          </div> */}
          <div className="link">
            <motion.button
              whileTap={{
                scale: 0.6,
              }}
            >
              <Link to="/java">查看課程</Link>
            </motion.button>
          </div>
          <div className="cline"></div>
        </motion.div>
        <motion.div variants={cardAnimation} className="card">
          <img src={AndroidCover} alt="" />
          <br />
          <br />
          <h2>
            <span>Android開發全攻略</span>
          </h2>
          <div className="content">
            <p>課程目標:</p>
            <p>
              從基礎到進階：設計模式、Kotlin語法、四個實作專案，逐步開發應用程式的基礎架構和進階實作！
            </p>
            <br />
            <p>學習內容:</p>
            <p>
              13種軟體設計模式、Kotlin語言的語法與概念、Android
              Studio、View與ViewGroup、實作四個App，包含繪圖軟體、重力五子棋遊戲、圖片搜尋系統、圖書館資料系統。
            </p>
          </div>
          <br />
          {/* <div className="link">
            <button
              style={{
                background: "grey",
                color: "white",
              }}
            >
              <Link style={{ border: "none", color: "white" }} to="/java">
                即將上市
              </Link>
            </button>
          </div> */}
          <div className="link">
            <motion.button
              whileTap={{
                scale: 0.6,
              }}
            >
              <Link to="/java">查看課程</Link>
            </motion.button>
          </div>
          <div className="cline"></div>
        </motion.div>
      </div>

      <div className="cards topMargin">
        <motion.div variants={cardAnimation} className="card">
          <img src={dataStructrue} alt="" />
          <br />
          <br />
          <h2>
            <span>資料結構與演算法</span>
          </h2>
          <div className="content">
            <p>課程目標:</p>
            <p>
              學習資料結構與演算法，深入了解演算法與資料結構邏輯，並用JavaScript來寫出程式碼。
            </p>
            <br />
            <p>學習內容:</p>
            <p>
              排序演算法、主定理、雜湊表、二元搜尋樹、優先佇列、霍夫曼演算法、最小生成樹、深度、寬度優先搜尋、最短路徑演算法、戴克斯特拉演算法、動態規劃等等。
            </p>
          </div>
          <br />
          <div className="link">
            <motion.button
              whileTap={{
                scale: 0.6,
              }}
            >
              <Link to="/dataStructure">查看課程</Link>
            </motion.button>
          </div>
          <div className="cline"></div>
        </motion.div>
        <motion.div variants={cardAnimation} className="card">
          <img src={DiscreteMath} alt="" />
          <br />
          <br />
          <h2>
            <span>離散數學與演算法</span>
          </h2>
          <div className="content">
            <p>課程目標:</p>
            <p>
              深入了解電腦科學中的數學邏輯，並使用Python與JavaScript(2擇1)來實現離散數學的結構。
            </p>
            <br />
            <p>學習內容:</p>
            <p>
              形式邏輯、證明、遞迴關係、函數分析、演算法、數論與密碼學、演算法分析、圖形理論、路徑選擇、機率、排列組合、電路邏輯、卡諾圖。
            </p>
          </div>
          <br />
          <div className="link">
            <motion.button
              whileTap={{
                scale: 0.6,
              }}
            >
              <Link to="/discrete">查看課程</Link>
            </motion.button>
          </div>
          <div className="cline"></div>
        </motion.div>
        <motion.div variants={cardAnimation} className="card">
          <img src={Cryptography} alt="" />
          <br />
          <br />
          <h2>
            <span>數論與密碼學</span>
          </h2>
          <div className="content">
            <p>課程目標:</p>
            <p>
              學習數論與密碼學，並且使用Python與JavaScript(2擇1)來實現現代密碼學的加密演算法。
            </p>
            <br />
            <p>學習內容:</p>
            <p>
              數論、模算數、質數驗證、中國剩餘定理、費馬定理、RSA加密系統、橢圓曲線加密演算法、DHKE密鑰交換演算法、數位簽章加密。
            </p>
          </div>
          <br />
          <div className="link">
            <motion.button
              whileTap={{
                scale: 0.6,
              }}
            >
              <Link to="/discrete">查看課程</Link>
            </motion.button>
          </div>
          <div className="cline"></div>
        </motion.div>
      </div>

      <div className="cards topMargin">
        <motion.div variants={cardAnimation} className="card">
          <img src={MathBro} alt="" />
          <br />
          <br />
          <h2>
            <span>線性代數</span>
          </h2>
          <div className="content">
            <p>課程目標:</p>
            <p>
              了解線性代數的數學原理、矩陣的運算、矩陣分解、空間向量，以及電腦科學的線性代數運用。
            </p>
            <br />
            <p>學習內容:</p>
            <p>
              主成分分析 (PCA)、QR分解、LU分解、特徵值分解、Python
              實作圖片分析、逆矩陣判斷、線性轉換、向量空間投影、行列式公式、歐拉公式。
            </p>
          </div>
          <br />
          {/* <div className="link">
            <button
              style={{
                background: "grey",
                color: "white",
              }}
            >
              <Link style={{ border: "none", color: "white" }} to="#">
                即將上市
              </Link>
            </button>
          </div> */}
          <div className="link">
            <motion.button
              whileTap={{
                scale: 0.6,
              }}
            >
              <Link to="/linearAlgebra">查看課程</Link>
            </motion.button>
          </div>
          <div className="cline"></div>
        </motion.div>
        <motion.div variants={cardAnimation} className="card">
          <img src={WebDevelopment} alt="" />
          <br />
          <br />
          <h2>
            <span>2022 網頁全端攻略</span>
          </h2>
          <div className="content">
            <p>課程目標:</p>
            <p>
              學習所有網頁前端與後端所需要知識與框架，連結資料庫，製作出6個美觀與實用的網站。
            </p>
            <br />
            <p>學習內容:</p>
            <p>
              HTML, CSS, JavaScript, SQL, Node.js, Express.js, EJS, MongoDB,
              Mongoose, Authentication, DOM, Hoisting, Scope, Closure, Prototype
              Inheritance.
            </p>
          </div>
          <br />
          <div className="link">
            <motion.button
              whileTap={{
                scale: 0.6,
              }}
            >
              <Link to="/webdev">查看課程</Link>
            </motion.button>
          </div>
          <div className="cline"></div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Courses;
